export default __webpack_public_path__ + "static/Workout-With-A-View-Muscle-Beach-California-92e495e49921c93812bb4681c1b56b40.jpg";